document.documentElement.classList.remove('no-js');
document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-ajax-cart]');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('[type="submit"]');
  if (button) button.disabled = true;
  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
    if (!response.ok) throw new Error('Unable to add item');
    window.location.href = window.Shopify.routes.root + 'cart';
  } catch (error) {
    alert(error.message);
    if (button) button.disabled = false;
  }
});
